// Textos por idioma de un alojamiento (reglas, sobre nosotros, espacios
// comunes, cocina, aseo y limpieza). Se guardan como JSON { es: "<p>…</p>", … };
// unas pocas filas viejas tienen texto suelto, que se toma como español.

export const IDIOMAS = ['es', 'en', 'pt', 'fr', 'it', 'de'];

function escapar(texto) {
    return String(texto).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

// Valor guardado → { idioma: html }.
export function textoPorIdioma(raw) {
    if (!raw) return {};
    try {
        const data = JSON.parse(raw);
        if (data && typeof data === 'object') return data;
    } catch (e) { /* texto suelto */ }
    return { es: `<p>${escapar(raw).replace(/\r?\n/g, '<br>')}</p>` };
}

// HTML para mostrar en el idioma actual: si falta, español y después cualquiera.
// Antes la ficha hacía JSON.parse(...)[locale] y un texto suelto la rompía.
export function textoHtml(raw, locale) {
    const data = textoPorIdioma(raw);
    const html = data[locale] || data.es || Object.keys(data).map(k => data[k]).find(Boolean) || '';
    return String(html).trim();
}

// HTML guardado → texto plano para editar (la API vuelve a armar el HTML).
export function htmlATexto(html) {
    if (!html) return '';
    const conSaltos = String(html)
        .replace(/<br\s*\/?>\s*\n?/gi, '\n')
        .replace(/<\/p>\s*<p[^>]*>/gi, '\n\n')
        .replace(/<\/(li|div|h[1-6])>/gi, '\n');
    const doc = new DOMParser().parseFromString(conSaltos, 'text/html');
    return (doc.body.textContent || '').replace(/\n{3,}/g, '\n\n').trim();
}

// Las listas de características del front (house-data / location-data) usan
// algunos nombres distintos de las columnas que manda la API: con el nombre de
// la lista esas características nunca se mostraban.
const ALIAS_CARACTERISTICA = {
    eprivado: 'estacionamiento_privado',
    evisita: 'estacionamiento_visita',
    ebicicleta: 'estacionamiento_bicicleta',
    sestar: 'sala_estar',
    seventos: 'sala_eventos',
    metro: 'estacion_metro',
    paradero: 'paradero_micro',
};

export function columnaCaracteristica(field) {
    return ALIAS_CARACTERISTICA[field] || field;
}
